// TT-291: OneTrust consent banner, the same install as pfida.com. Pfida only (caller checks tenant).

export const ONETRUST_STUB_URL = 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
// pfida.com's production settings; app.pfida.com sits under the same root domain
export const ONETRUST_DOMAIN_SCRIPT = 'fa5fdff1-68ac-4eba-bf31-08cffbc531bd';

type OneTrustWindow = Window & { OptanonWrapper?: () => void };

/** Returns true when this call injected the stub; never throws. */
export function loadOneTrust(): boolean {
  try {
    if (document.querySelector(`script[src="${ONETRUST_STUB_URL}"]`)) {
      return false;
    }
    const win = window as OneTrustWindow;
    // OneTrust calls this on load and on every change; the consent bridge listens to its event instead
    if (!win.OptanonWrapper) {
      win.OptanonWrapper = () => {};
    }

    const script = document.createElement('script');
    script.src = ONETRUST_STUB_URL;
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.dataset.domainScript = ONETRUST_DOMAIN_SCRIPT;
    document.head.prepend(script);
    return true;
  } catch {
    return false;
  }
}
